export const companyUserPermissions = {
  SEND_PIX : 'send-pix',
  SEND_TED : 'send-ted',
  PAY_BOLETO : 'pay-boleto',
  CREATE_PIX_KEY : 'create-pix-key',
  VIEW_STATEMENT : 'view-statement',
  CREATE_BOLETO : 'create-boleto',
  EXPORT_STATEMENT : 'export-statement',
  PAY_PIX_COPY_PASTE : 'pay-pix-copy-paste',
  DELETE_PIX_KEY : 'delete-pix-key',
  CREATE_PIX_CHARGE : 'create-pix-charge',
  UPDATE_PIX_LIMITS : 'update-pix-limits',
  UPDATE_TED_LIMITS : 'update-ted-limits',
  SEND_ECHECK : 'send-echeck',
  VIEW_BALANCE : 'view-balance',
  CREATE_PIX_KEY : 'create-pix-key',
  UPDATE_PIX_KEY : 'update-pix-key',
  DELETE_PIX_KEY : 'delete-pix-key',
  VIEW_PIX_KEY : 'view-pix-key',
  CREATE_PIX_CHARGE : 'create-pix-charge',
  VIEW_PIX_LIMITS : 'view-pix-limits',
  VIEW_TED_LIMITS : 'view-ted-limits',
  APPROVE_BATCH_PAYMENT : 'approve-batch-payment',
}